import React, { useEffect, useState } from "react";
import { SearchInputWrapper } from "../../../../components/common/datatable/filter/SearchInputWrapper";
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import { DataTable } from "../../../../components/common/datatable/DataTable";
import IconButton from "../../../../components/common/form/IconButton";
import { FaPlus } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { useGetEnumsQuery } from "../../../../app/globalApi";
import { createClickableLink } from "../../../../components/common/datatable/DataTableUtils";
import {
    SearchSelectWithEnum,
    SearchSelectWithList
} from "../../../../components/common/datatable/filter/SearchSelectWrapper";
import { getEnumDisplayNameByConstant } from "../../../../helpers/utils/EnumUtils";
import { useDeleteBulkAssociationsMutation, useLazyExportAssociationDataQuery, useSearchAssociationApiQuery } from "../associationApi";
import { useFindUserSettingsByGroupNameQuery } from "../../../../components/common/userSetting/userSettingsApi";
import { useGetAllStatesQuery } from "../../../data/states/statesApi";
import { useLazyGetAllCountyByStateAbbrQuery } from "../../../data/counties/countiesApi";
import ManagmentCompanySearchInputWrapper from "../../../../components/common/datatable/filter/ManagementCompanySearchInputWrapper";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";
import { getStateValueFromParam } from "../../../../helpers/utils/Utils";

const Associations = () => {
    const { data: enums } = useGetEnumsQuery("");
    const navigate = useNavigate()
    const { data: userSetting } = useFindUserSettingsByGroupNameQuery("Association");
    const stateDataApi = useGetAllStatesQuery("");
    const [triggerExportAssociationDataQuery] = useLazyExportAssociationDataQuery();
    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Associations", url: "" }]
    )
    const [getAllCountyByStateAbbrApi, getAllCountyByStateAbbrApiResponse] = useLazyGetAllCountyByStateAbbrQuery()
    const [deleteBulkAssociations] = useDeleteBulkAssociationsMutation();
    const state = getStateValueFromParam(window);


    useEffect(() => {
        getAllCountyByStateAbbrApi(state);
    }, [state]);
    
    useEffect(() => {
        document.title = 'Associations';
    });

    const columns: DataTableColumn[] = [
        {
            label: "Name", accessor: "name", visibility: { hasShowSetting: false },

            cell: (props: any) => {
                if (hasPermission(["ASSOC-R"])) {
                    let path = "/associations/" + props.row.original.id;
                    return createClickableLink(path, props.value, userSetting);
                } else {
                    return <>
                        <span>{props.row.original.name}</span>
                    </>
                }
            },
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Name..."} name={"name"}
                    accessor={"name"} />,
            }],
        },

        {
            label: "State", accessor: "state", overrideSortColumn: "county.state.stateName",
            cell: (props: any) => {
                return <><span>{props.row.original?.county?.state?.stateName}</span></>
            },
            filterOptions: [{
                dependentColumns: ["County"],
                filterComponent: SearchSelectWithList(stateDataApi?.data, "stateName", "stateAbbreviation", "Select State...", false, "state"),

            }]
        },
        {

            label: "County", accessor: "countyId", overrideSortColumn: "county.countyName",
            cell: (props: any) => {
                return <><span>{props.row.original?.county?.countyName}</span></>
            }, filterOptions: [{
                filterComponent: SearchSelectWithList(getAllCountyByStateAbbrApiResponse?.data, "countyName", "id", "Select County...", false, "countyId"),
                onDependencyUpdated: (value: string) => {
                    getAllCountyByStateAbbrApi(value);
                },
            }]
        },

        {
            label: "Management Company", accessor: "managementCompany.name",
            filterOptions: [{
                filterComponent: <ManagmentCompanySearchInputWrapper accessor="managementCompanyId" />,
                overrideFilterAccessor: "managementCompanyId",
                overrideFilterLabel: "Management Company",
            }]

        },
        {
            label: "Status", accessor: "status",
            cell: (props: any) => {
                return <>
                    <span>{getEnumDisplayNameByConstant(enums?.["AssociationStatus"], props.value)}</span>
                </>
            },
            filterOptions: [{
                filterComponent: SearchSelectWithEnum(enums?.["AssociationStatus"], "Select Status...", false, "status"),
            }],
        },
    ]

    return (
        <div className="px-4 py-2">
            <div className="flex justify-between mb-2.5">
                <Breadcrumb crumbs={crumbs} />
            </div>

            <DataTable
                columns={columns}
                actions={{
                    fetchAction: useSearchAssociationApiQuery,
                    exportAction: triggerExportAssociationDataQuery,
                    deleteAction: deleteBulkAssociations
                }}
                hasBulkDelete={true}
                rowSelectionOptions={{
                    enableMultiRowSelection: true,
                    onSelectionChange: () => { }

                }}
                buttonOptions={{
                    addButton:
                    {
                        button: <IconButton
                            icon={<FaPlus />}
                            hasBackground={true}
                            onClick={() => {
                                navigate("/associations/create")
                            }}
                            title={"Add Association"}
                        />,
                        permissions: ["ASSOC-C"]
                    },
                }}

                userSettingGroup={"Association"}
                defaultSortOptions={{
                    accessor: "name",
                    direction: "asc"
                }}
                defaultFilter={{
                    state: "TX"
                }}
                basePermission={"ASSOC"}
            />
        </div>
    );
}

export default Associations;